module.exports = __webpack_public_path__ + "media/images/career_camp/2022/texts/get_ready-4e2bbca6eb7aea86ada224612dbe6d0b.svg";